import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../auth/services/token.service';
import { AuthService } from '@shared/core/auth';
import { Auth } from '@angular/fire/auth';
import { filter, from, switchMap, take } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
const authService = inject(AuthService);
  const auth = inject(Auth);

  // Always call getIdToken() directly on the Firebase user — not the cached
  // signal value. Firebase's getIdToken() checks expiry internally and
  // auto-refreshes within the ~5-minute buffer, so we always get a valid JWT.
  const attachToken = () =>
    from(auth.currentUser?.getIdToken() ?? Promise.resolve(null)).pipe(
      switchMap(token => {
        if (!token) return next(req);
        return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
      })
    );

  // If Firebase already resolved the session (most requests after cold start),
  // skip the toObservable overhead — signal is readable synchronously.
  if (authService.isReady()) {
    return attachToken();
  }

  // Cold start / page refresh: wait for onIdTokenChanged to fire before
  // letting any request through.
  return toObservable(authService.isReady).pipe(
    filter(ready => ready === true),
    take(1),
    switchMap(() => attachToken())
  );
};
